import React from "react";
import "./deferral-election-table.scss";
import { deferralsSelector } from "../../../../reducers/deferrals/defferals";
import { useSelector } from "react-redux";
import { DeferralElection } from "../../../../models/deferrals";
import {
  formatDateWithoutTimeZone,
  yyyy_mm_dd,
} from "../../../../util/date-util";

export default function DeferralElectionTable() {
  const deferrals = useSelector(deferralsSelector);
  const firstDayOfYearFormatted: string = formatDateWithoutTimeZone(
    new Date(new Date().getFullYear(), 0, 1),
    yyyy_mm_dd
  );

  return (
    <>
      {deferrals && deferrals.data && (
        <div className="custom-table-wrapper">
          <table>
            <thead>
              <tr>
                <th className="left-align header">Compensation Type</th>
                <th className="left-align header">
                  Current Deferral Elections{" "}
                  <sup>
                    [
                    <a href="#[1]">
                      <span className="sr-only">Footnote&nbsp;</span>1
                    </a>
                    ]
                  </sup>
                </th>
                <th className="left-align header">Effective Date</th>
              </tr>
            </thead>
            <tbody>
              {deferrals.data.employees[0].deferrals.map(
                (value: DeferralElection) => {
                  return (
                    <tr>
                      <td className="left-align">
                        {value.displayCompTypeName}
                      </td>
                      <td className="left-align">
                        {value.displayAmount} per payment
                      </td>
                      <td className="left-align">
                        {value.wasDefaultedToZero
                          ? firstDayOfYearFormatted
                          : value.effectiveDateDisplay}
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
